/**
 * Where each assessed area's own findings page lives, for anything that links to one (the
 * dashboard's area rows, owner 2026-09-25: "clicking on the bars ... identity should take us to the
 * identity findings").
 *
 * The same four areas ShellPlaceholder.tsx mounts as pages (AREA_FOR_PATH, which records why AI and
 * Compliance have none). An area missing here simply is not a link -- never a link to a page that
 * would show another area's findings or none at all.
 */
export const AREA_PAGES: Readonly<Record<string, string>> = {
  Identity: '/identity',
  Endpoint: '/endpoint',
  Email: '/email',
  Data: '/data',

  // Present in a dashboard row only where Azure is assessed (the server's assessedAreas); /cloud
  // redirects elsewhere, so this never links to a page that is not there.
  Cloud: '/cloud',

  // Likewise only where the AI area is on (the server's assessedAreas); /ai redirects elsewhere.
  AI: '/ai',
}
